<template>
  <SameAthleteState v-if="isSameAthlete" :athlete="athlete" />
  <CollegeCoachState v-else-if="isCollegeCoach" :athlete="athlete" />
  <DefaultState v-else :athlete="athlete" />
</template>

<script>
import SameAthleteState from "./EmptyStates/SameAthlete.vue";
import CollegeCoachState from "./EmptyStates/CollegeCoach.vue";
import DefaultState from "./EmptyStates/Default.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SameAthleteState,
    CollegeCoachState,
    DefaultState
  },

  props: {
    athlete: { type: Object, required: true }
  },

  computed: {
    ...mapGetters({
      isSameAthlete: "athleteProfile/isCurrentUser",
      isCollegeCoach: "userData/isCollegeCoach"
    })
  }
};
</script>